import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { GroupingState } from "./grouping-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class GroupingQuestionStateProtobufSerializer
  implements Api.StateSerializationPlugin<GroupingState> {
  key = {
    id: 17,
    name: { ns: "suspend-data", name: "question-state-grouping" },
    format: "protobuf"
  };

  serialize(data: GroupingState): Result<Uint8Array, Api.SerializerError> {
    const message = new GroupingStateProtoMessage({
      cardsOrder: data.cardsOrder,
    });

    return ProtobufSerializer.serialize<GroupingStateProtoMessage>(
      message,
      GroupingStateProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<GroupingState, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      GroupingStateProtoMessage
    >(content, GroupingStateProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: GroupingState = {
      cardsOrder: message.cardsOrder
    };

    return ok(result);
  }
}

@Type.d("GroupingStateProtoMessage")
class GroupingStateProtoMessage extends Message<GroupingStateProtoMessage> {
  @Field.d(1, "string", "repeated")
  cardsOrder: string[];
}
